import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { WindowMU } from "app/types/WindowMU"

declare var window:WindowMU

export async function alterarTipoFreteVariosItensOrcamento({
    identificadoresItens,idTipoFreteOuFreteEspecial,ehFreteEspecial
}: {
    identificadoresItens:number[],
    idTipoFreteOuFreteEspecial:number, 
    ehFreteEspecial:boolean
}) {
    const identificadorOrcamento = store.getState().orcamento.IdentificadorOrcamento

    const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarTipoFreteVariosItens(identificadorOrcamento, identificadoresItens, idTipoFreteOuFreteEspecial, ehFreteEspecial)

    window.orcamentoController.model.atualizar(orcamentoAtualizado,true,true,true)

}